import { Card, Space } from 'antd';
import { FC, memo } from 'react';

import { HostingAccountsCreateForm } from '../HostingAccountsForm';
import { HostingAccountsList } from '../HostingAccountsList';

interface Props {
  hostingId: string;
}

export const HostingAccountsOverviewView: FC<Props> = memo(({ hostingId }) => {
  return (
    <Card>
      <Space direction="vertical" size="small" className="ant-space-fullwidth">
        <HostingAccountsCreateForm hostingId={ hostingId }/>

        <HostingAccountsList hostingId={ hostingId }/>
      </Space>
    </Card>
  );
});
